class KeyfigurePopup {
  constructor() {
    this.currentIndex = 0;
    this.init();
  }

  init() {
    this.keyfigureContainer = document.querySelector('.ns-keyfigure-new__inner');
    this.items = document.querySelectorAll('.ns-keyfigure-new__item');

    if (this.keyfigureContainer && this.items.length > 0) {
      document.querySelectorAll('.ns-keyfigure-new__icon').forEach(icon => {
        if (!icon.style.backgroundImage || icon.style.backgroundImage === 'none') {
          icon.classList.add('no-popup');
          const item = icon.closest('.ns-keyfigure-new__item');
          if (item) item.classList.add('no-popup');
        }
      });
      this.handleSlider();
      this.handlePopup();
    }
  }

  handlePopup() {
    const openPopup = (e) => {
      const container = e.target.closest('.ns-keyfigure-new__item-container');
      const popup = container ? container.querySelector('.ns-keyfigure-new__popup') : null;
      document.querySelectorAll('.ns-keyfigure-new__popup.open').forEach(p => {
        p.classList.remove('open');
        const swiperCont = p.closest('.swiper-container-mobile') || p.closest('.swiper-container-startpage');
        if (swiperCont) swiperCont.classList.remove('popup-open');
      });
      if (popup) {
        popup.classList.add('open');
        const swiperCont = popup.closest('.swiper-container-mobile') || popup.closest('.swiper-container-startpage');
        if (swiperCont) swiperCont.classList.add('popup-open');
        // Stop autoplay
        if (window.desktopSwiper && window.desktopSwiper.autoplay) window.desktopSwiper.autoplay.stop();
        if (window.mobileSwiper && window.mobileSwiper.autoplay) window.mobileSwiper.autoplay.stop();
        // Disable swiper interaction
        if (window.mobileSwiper) {
          window.mobileSwiper.allowTouchMove = false;
          window.mobileSwiper.allowSlideNext = false;
          window.mobileSwiper.allowSlidePrev = false;
        }

        const navButtons = document.querySelectorAll('.swiper-button-next, .swiper-button-prev');
        navButtons.forEach(btn => btn.style.pointerEvents = 'none');
      }
    };

    document.addEventListener('click', (e) => {
      if (e.target.matches('.ns-keyfigure-new__top') || e.target.closest('.ns-keyfigure-new__top')) {
        const topElement = e.target.closest('.ns-keyfigure-new__top');
        const icon = topElement.querySelector('.ns-keyfigure-new__icon');
        if (icon && !icon.classList.contains('no-popup')) {
          openPopup(e);
        }
      }
    });

    document.addEventListener('focus', (e) => {
      if (e.target.matches('.ns-keyfigure-new__top')) {
        const topElement = e.target;
        const icon = topElement.querySelector('.ns-keyfigure-new__icon');
        if (icon && !icon.classList.contains('no-popup')) {
          openPopup(e);
        }
      }
    }, true);

    document.addEventListener('click', (e) => {
      if (e.target.matches('.ns-keyfigure-new__popup-close') || e.target.closest('.ns-keyfigure-new__popup-close')) {
        const popup = e.target.closest('.ns-keyfigure-new__popup');
        if (popup) {
          popup.classList.remove('open');

          const swiperCont = popup.closest('.swiper-container-mobile') || popup.closest('.swiper-container-startpage');
          if (swiperCont) swiperCont.classList.remove('popup-open');

          // Re-enable swiper interaction
          if (window.mobileSwiper) {
            window.mobileSwiper.allowTouchMove = true;
            window.mobileSwiper.allowSlideNext = true;
            window.mobileSwiper.allowSlidePrev = true;
          }
          // Show navigation buttons
          const navButtons = document.querySelectorAll('.swiper-button-next, .swiper-button-prev');
          navButtons.forEach(btn => btn.style.pointerEvents = 'auto');

          if (window.desktopSwiper && window.desktopSwiper.autoplay) window.desktopSwiper.autoplay.start();
          if (window.mobileSwiper && window.mobileSwiper.autoplay) window.mobileSwiper.autoplay.start();
        }
        e.stopPropagation();
      }
    });

    document.addEventListener('scroll', () => {
      const popups = document.querySelectorAll('.ns-keyfigure-new__popup.open');
      popups.forEach(popup => {
        popup.classList.remove('open');
        // Remove class from swiper container
        const swiperCont = popup.closest('.swiper-container-mobile') || popup.closest('.swiper-container-startpage');
        if (swiperCont) swiperCont.classList.remove('popup-open');
        // Re-enable swiper interaction
        if (window.mobileSwiper) {
          window.mobileSwiper.allowTouchMove = true;
          window.mobileSwiper.allowSlideNext = true;
          window.mobileSwiper.allowSlidePrev = true;
        }
        // Show navigation buttons
        const navButtons = document.querySelectorAll('.swiper-button-next, .swiper-button-prev');
        navButtons.forEach(btn => btn.style.pointerEvents = 'auto');
        // Start autoplay
        if (window.desktopSwiper && window.desktopSwiper.autoplay) window.desktopSwiper.autoplay.start();
        if (window.mobileSwiper && window.mobileSwiper.autoplay) window.mobileSwiper.autoplay.start();
      });
    });
  }


  handleSlider() {
    const prevButton = document.querySelector(".ns-keyfigure-new__arrow--left");
    const nextButton = document.querySelector(".ns-keyfigure-new__arrow--right");

    const updateSliderPosition = () => {

      this.items.forEach((item, index) => {
        item.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      });
    };

    if (prevButton && nextButton) {
      prevButton.addEventListener("click", () => {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          updateSliderPosition();
        }
      });

      nextButton.addEventListener("click", () => {
        if (this.currentIndex < this.items.length - 1) {
          this.currentIndex++;
          updateSliderPosition();
        }
      });
    }
    updateSliderPosition();
  }
}

export default KeyfigurePopup;




// class KeyfigurePopup {
//   constructor() {
//     this.currentIndex = 0;
//     this.init();
//   }

//   init() {
//     this.keyfigureContainer = document.querySelector('.ns-keyfigure-new__inner');
//     this.items = document.querySelectorAll('.ns-keyfigure-new__item');

//     if (this.keyfigureContainer && this.items.length > 0) {
//       this.handleSlider();
//       this.handlePopup();
//     }
//   }

//   handlePopup() {
//     const toggles = document.querySelectorAll('.ns-keyfigure-new__icon');

//     toggles.forEach((toggle, index) => {
//       const popup = document.querySelector(`.ns-keyfigure-new__popup-${index + 1}`);

//       const openPopup = () => {
//         document.querySelectorAll('.ns-keyfigure-new__popup.open').forEach(popup => {
//           popup.classList.remove('open');
//         });

//         if (popup) {
//           popup.classList.add('open');
//         }
//       };

//       toggle.addEventListener("click", openPopup);
//       toggle.addEventListener("focus", openPopup);
//     });

//     document.querySelectorAll('.ns-keyfigure-new__popup-close').forEach(closeButton => {
//       closeButton.addEventListener("click", (e) => {
//         const popup = closeButton.closest('.ns-keyfigure-new__popup');
//         if (popup) {
//           popup.classList.remove('open');
//         }
//         e.stopPropagation();
//       });
//     });

//     document.addEventListener("scroll", () => {
//       const popups = document.querySelectorAll('.ns-keyfigure-new__popup.open');
//       popups.forEach(popup => {
//         popup.classList.remove('open');
//       });
//     });
//   }


//   handleSlider() {
//     const prevButton = document.querySelector(".ns-keyfigure-new__arrow--left");
//     const nextButton = document.querySelector(".ns-keyfigure-new__arrow--right");

//     const updateSliderPosition = () => {

//       this.items.forEach((item, index) => {
//         item.style.transform = `translateX(-${this.currentIndex * 100}%)`;
//       });
//     };

//     if (prevButton && nextButton) {
//       prevButton.addEventListener("click", () => {
//         if (this.currentIndex > 0) {
//           this.currentIndex--;
//           updateSliderPosition();
//         }
//       });

//       nextButton.addEventListener("click", () => {
//         if (this.currentIndex < this.items.length - 1) {
//           this.currentIndex++;
//           updateSliderPosition();
//         }
//       });
//     }
//     updateSliderPosition();
//   }
// }

// export default KeyfigurePopup;
